/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import { useRecoilValue } from "recoil";
import TriangleAlert from "../../../../assets/icon/triangle-alert";
import { NumberOfTagsInCategoryAtom } from "../../../../atoms/SelectedCategoriesAtom";
import { UpdateCategoryIRoute } from "../../../../generated/Api";
import StyledCheckBox from "../../../StyledCheckBox";

interface TableProps {
  check: boolean;
}

interface GridRowProps {
  restricted: boolean;
}

const Row = styled(motion.div)<TableProps>`
  display: grid;
  border: 1px solid;
  border-color: ${(props) => (props.check ? "#FB972E" : "#eaeaeabf")};
  background-color: ${(props) =>
    props.check ? "rgb(251, 151, 46, 0.05)" : "#ffffff"};
  grid-template-rows: 1fr;
  align-items: center;
`;

const GridRow = styled(motion.div)<GridRowProps>`
  width: 100%;
  height: 60px;

  background-color: #ffffff;

  display: grid;

  grid-template-columns: 1fr 0.5fr;

  grid-column-gap: 24px;

  padding: 15px 25px;

  align-items: center;
  justify-content: space-between;

  cursor: ${(props) => (props.restricted ? "default" : "pointer")};

  @media screen and (max-width: 1010px) {
    width: fit-content;
  }
`;

const TableTitle = styled.div`
  color: #2f2f2f;
  display: flex;
  font-size: 16px;
  align-items: center;
  /* overflow: hidden; */
  max-width: 100%;
`;

const WrapperCheckboxAndTitle = styled.div<{ hasCampaign: boolean }>`
  display: flex;
  align-items: center;
  justify-content: start;

  .css-17ninii {
    border: ${(props) => props.hasCampaign && "1px solid #c40000 !important"};
    background: ${(props) =>
      props.hasCampaign && "#f8f8f8 0% 0% no-repeat padding-box"};
  }
`;

interface Props {
  row: UpdateCategoryIRoute;
  categoriesReadyToBeDeleted: UpdateCategoryIRoute[];
  categoriesRestricted: UpdateCategoryIRoute[];
  isChecked: boolean;
  handleCheck: () => void;
}

export default function TableRowCategories(props: Props): JSX.Element {
  const {
    row,
    categoriesReadyToBeDeleted,
    categoriesRestricted,
    handleCheck,
    isChecked,
  } = props;
  const numberOfTags = useRecoilValue(NumberOfTagsInCategoryAtom);

  const isRestrictedCategory =
    categoriesRestricted &&
    categoriesRestricted.find(
      (categoryRestricted) => categoryRestricted._id === row._id
    );

  return (
    <Row
      check={!isRestrictedCategory && isChecked}
      layout
      css={css`
        margin-top: 7px;
      `}
    >
      <AnimatePresence>
        <GridRow
          restricted={!!isRestrictedCategory}
          layout
          onClick={() => {
            !isRestrictedCategory && handleCheck();
          }}
        >
          <WrapperCheckboxAndTitle hasCampaign={!!isRestrictedCategory}>
            {!isRestrictedCategory ? (
              <StyledCheckBox check={isChecked} handleCheck={handleCheck} />
            ) : (
              <div style={{ marginLeft: "3.5px", marginRight: "2px" }}>
                <TriangleAlert />
              </div>
            )}
            <TableTitle style={{ marginLeft: "16px" }}>{row.name}</TableTitle>
          </WrapperCheckboxAndTitle>
          <TableTitle>{numberOfTags[row._id] || 0}</TableTitle>
        </GridRow>
      </AnimatePresence>
    </Row>
  );
}
